//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Selection Context
//
//  Copyright:    © 2025 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//region Version 1.0.7.0
//    001   08.12.25 Sean Flook      IMANN-2196 Initial Revision.
//endregion Version 1.0.7.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

//region imports

import React from "react";

//endregion imports

const SelectionContext = React.createContext();
SelectionContext.displayName = "SelectionContext";

export default SelectionContext;
